export const POINTS_INFO_STARTED = 'POINTS_INFO_STARTED'
export const POINTS_INFO_SUCCESS = 'POINTS_INFO_SUCCESS'
export const POINTS_INFO_FAILURE = 'POINTS_INFO_FAILURE'
